/* eslint-disable */
export default {
  dial: '拨号',
  message: '发送消息',
  transfer: '转接',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
